import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const wsUrl = (roomId, username, avatar, active = true, token = null) => {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const params = new URLSearchParams({ username, active: active ? "true" : "false" });
  if (avatar) params.set("avatar", avatar);
  if (token) params.set("token", token);
  return `${base}/api/ws/${roomId}?${params.toString()}`;
};

export const mediaUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export const login = async (username, avatar) => {
  const { data } = await axios.post(`${API}/auth/login`, { username, avatar });
  return data;
};

export const fetchRooms = async () => {
  const { data } = await axios.get(`${API}/rooms`);
  return data;
};

export const createRoom = async (name, description = "", createdBy = null, adminUsername = null, adminPassword = null, logo = null) => {
  const { data } = await axios.post(`${API}/rooms`, {
    name, description, logo: logo || null, created_by: createdBy,
    admin_username: adminUsername || null, admin_password: adminPassword || null,
  });
  return data;
};

export const setRoomLogo = async (token, roomId, logo) => {
  const { data } = await axios.post(`${API}/rooms/${roomId}/logo`, { logo: logo || null }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const adminLogin = async (username, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  return data;
};

export const fetchMyRooms = async (token) => {
  const { data } = await axios.get(`${API}/admin/my-rooms`, { headers: { Authorization: `Bearer ${token}` } });
  return data;
};

export const fetchAdminInbox = async (token) => {
  const { data } = await axios.get(`${API}/admin/inbox`, { headers: { Authorization: `Bearer ${token}` } });
  return data;
};

export const setRoomAdmin = async (token, roomId, adminUsername, adminPassword) => {
  const { data } = await axios.post(
    `${API}/admin/rooms/${roomId}/set-admin`,
    { admin_username: adminUsername, admin_password: adminPassword },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const fetchConfig = async () => {
  const { data } = await axios.get(`${API}/config`);
  return data;
};

export const fetchGroups = async () => {
  const { data } = await axios.get(`${API}/groups`);
  return data;
};

export const fetchGroup = async (groupId) => {
  const { data } = await axios.get(`${API}/groups/${groupId}`);
  return data;
};

export const createGroup = async (token, name, description = "", roomIds = []) => {
  const { data } = await axios.post(
    `${API}/groups`,
    { name, description, room_ids: roomIds },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const updateGroup = async (token, groupId, patch) => {
  const { data } = await axios.put(`${API}/groups/${groupId}`, patch, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const deleteGroup = async (token, groupId) => {
  const { data } = await axios.delete(`${API}/groups/${groupId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const fetchUsers = async () => {
  const { data } = await axios.get(`${API}/users`);
  return data;
};

export const fetchMessages = async (roomId) => {
  const { data } = await axios.get(`${API}/rooms/${roomId}/messages`);
  return data;
};

export const fetchPinned = async (roomId) => {
  const { data } = await axios.get(`${API}/rooms/${roomId}/pinned`);
  return data;
};

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.image_url;
};
